<agpr-take-over-panel
    [id]="id"
    header="Discover.dialogs.browsers.subject.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [responsiveWidth]="true"
    [minPanelWidth]="830"
    [maxPanelWidth]="1000"
    (closeTakeover)="closeDialog(null)"
>
    <div class="lhp">
        <h4 [id]="id + '_availableItems_heading'"> {{ 'Discover.dialogs.subject.availableSubjects' | localize }} </h4>
        <agpr-text-input
            [id]="id + '.quickFilter'"
            class="lhp-search"
            [(ngModel)]="filterString"
            (ngModelChange)="filterChange()"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            ariaLabel="Common.dialog.dataSelect.filterPlaceholder"
            placeholder="Common.dialog.dataSelect.filterPlaceholder"
            [initialFocus]="true"
            [bottomMargin]="false"
        ></agpr-text-input>

        @if (filterString.length === 0) {
            <agpr-tabs
                class="lhp-tabs"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabChange($event)"
                [useContentContainer]="false"
            >
                <agpr-tab
                    [id]="id + '_general'"
                    heading="Discover.dialogs.subject.general"
                ></agpr-tab>
                <agpr-tab
                    [id]="id + '_regional'"
                    heading="Discover.dialogs.subject.regional"
                ></agpr-tab>
            </agpr-tabs>
        }

        <agpr-scroll-panel #scrollPanel>
            @if (selectedTabIndex === subjectTabType.general) {
                <agpr-tree-list
                    class="lhp-treelist"
                    [items]="generalOptions"
                    [(selection)]="selectedGeneral"
                    (selectionChange)="selectionChange()"
                    [filterString]="filterString.length > 2 ? [filterString] : []"
                ></agpr-tree-list>
            } @else if (selectedTabIndex === subjectTabType.regional) {
                <agpr-tree-list
                    class="lhp-treelist"
                    [items]="regionalOptions"
                    [(selection)]="selectedRegional"
                    (selectionChange)="selectionChange()"
                    [filterString]="filterString.length > 2 ? [filterString] : []"
                ></agpr-tree-list>
            }
            @if (emptySubjects) {
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{ 'Common.forms.treeList.noResultsMasculine' | localize: { type: 'Discover.dialogs.browsers.subject.header' } }}
                    </span>
                </agpr-message>
            }
        </agpr-scroll-panel>
        @if (filterString.length > 0) {
            <div class="suggestions">
                <h4 [id]="id + '_suggestions_heading'">{{ 'Discover.dialogs.browseAll.subjectsRelatedTo.header' | localize: { subject : filterString } }}</h4>
            </div>
            <agpr-scroll-panel>
                @if (suggestions.length > 0) {
                    <agpr-tree-list
                        class="agpr-dataSelectDialogContent-treelist agpr-dataSelectDialogContent-treelist--suggestions"
                        [items]="suggestions"
                        [(selection)]="selectedSuggestions"
                        (nodeUnselect)="suggestionUnselect($event)"
                        (nodeSelect)="suggestionSelect($event)"
                        [filterString]="filterString.length > 2 ? [filterString] : []"
                        [hideParentCheckbox]="false"
                    ></agpr-tree-list>
                } @else {
                    <agpr-message
                        [severity]="messageSeverityEnum.noContent"
                        class="suggestions--noResults"
                    >
                        <span>
                            {{ 'Common.forms.treeList.noResultsMasculine' | localize: { type: 'Discover.dialogs.browsers.subject.header' } }}
                        </span>
                    </agpr-message>
                }
            </agpr-scroll-panel>
        }
    </div>
    <div class="rhp">
        <h4 [id]="id + '_selectedItems_heading'"> {{ 'Discover.dialogs.subject.selectedSubjects' | localize }} </h4>
        <agpr-scroll-panel>
            <ul class="rhp-groups">
                @for (chipGroup of chipGroups; track chipGroup; let i = $index) {
                    <li>
                        <span class="rhp-chipGroup">
                            {{ chipGroup.heading | localize }}
                        </span>
                        <ul
                            [id]="'selectedGroup_' + i"
                            class="rhp-contents"
                            agprListKeyboardNavigation
                            listOrientation="horizontal"
                            [focusOnChild]="true"
                            [list]="chipGroup.chips"
                            role="group"
                            [attr.aria-label]="chipGroup.heading | localize"
                        >
                            @for (chip of chipGroup.chips; track chip; let j = $index) {
                                <li
                                    [id]="id + '_chip_' + j"
                                    class="agpr-chip"
                                >
                                    <span
                                        class="agpr-chip-label"
                                        [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize)"
                                        tooltipPosition="top"
                                    >
                                        {{ chip.label | localize }}
                                    </span>
                                    <agpr-button
                                        [id]="id + '.chip_' + i + '.delete'"
                                        class="agpr-chip-button"
                                        [style]="buttonType.icon"
                                        icon="agpr-i-close"
                                        tooltip="Common.forms.chips.delete"
                                        tooltipPosition="top"
                                        [ariaLabel]="(chip.label | localize) + ' ' + ('Common.forms.chips.delete' | localize)"
                                        (click)="removeChip(chip)"
                                    ></agpr-button>
                                </li>
                            }

                        </ul>
                    </li>
                }
            </ul>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="closeDialog(null)"
            [style]="buttonType.secondary"
            label="cancel"
        ></agpr-button>
        <agpr-button
            (click)="resetAll()"
            [style]="buttonType.secondary"
            label="Discover.dialogs.browsers.subject.button.resetAll"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            (click)="apply()"
            [style]="buttonType.primary"
            label="Discover.dialogs.browsers.subject.button.applySelected"
        ></agpr-button>
    </ng-template>

</agpr-take-over-panel>
